export const voidAsync = <T, Args extends readonly unknown[]>(
  fn: (...args: Args) => Promise<T>,
  catchFn: (error: unknown) => void = (error) => {
    // eslint-disable-next-line no-console
    console.error('Error in voidAsync', error)
  },
): ((...args: Args) => void) => {
  return (...args: Args): void => {
    fn(...args).catch(catchFn)
  }
}
